import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import GalleryContainerCard from '../../components/GalleryContainerCard';
import ListingContext from '../../providers/Listing/Listing.context';
import ListingInProtfolioEmptyState from 'components/ListingInProtfolioEmptyState';
import HelmetWrapper from 'components/HelmetWrapper';
import VisibilityBanners from '../../components/VisibilityBanners';
import { checkIsNoListing } from 'utils';

import './ListingInformation.styles.scss';
import './ListingInformation.styles.responsive.scss';

const ListingInformationRouter: React.FC = () => {
  const {
    gallery,
    areActionsDisabled,
    dealRoom: { name, listingStage, listingIM },
    listing: { listingTitle, dealRoomId, type, _id: listingId },
  } = useContext(ListingContext);

  const isNoListing = checkIsNoListing(listingStage);

  const showContent = !isNoListing;

  return (
    <div className="listing-information-router">
      <HelmetWrapper title={`Listing - ${listingTitle || name}`} />

      <VisibilityBanners />

      <div className="listing-info__content">
        <main>
          {showContent ? (
            <Outlet />
          ) : (
            <ListingInProtfolioEmptyState
              dealRoomId={dealRoomId}
              listingType={type}
              listingId={listingId}
              isDisabled={areActionsDisabled}
              listingIM={listingIM}
            />
          )}
        </main>

        <aside>
          {showContent && (
            <GalleryContainerCard
              gallery={gallery}
              dealRoomId={dealRoomId}
              isDisabled={areActionsDisabled}
            />
          )}
        </aside>
      </div>
    </div>
  );
};

export default ListingInformationRouter;
